import { __assign, __extends, __spreadArrays } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import { LabelsSelectorEvents, } from '../../constants/events';
import { MultiSelect, TextButton } from 'wix-style-react';
var LabelsSelector = /** @class */ (function (_super) {
    __extends(LabelsSelector, _super);
    function LabelsSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.convertLabelToOption = function (label) {
            return __assign(__assign({}, label), { id: label.id, value: label.name });
        };
        _this.fireOnChange = function (_a) {
            var _b = _a.labels, labels = _b === void 0 ? [] : _b, _c = _a.newLabels, newLabels = _c === void 0 ? [] : _c;
            var labelIds = labels.map(function (l) { return l.id; });
            var newLabelsNames = newLabels.map(function (l) { return l.name; });
            return _this.props.onChange({
                labels: labelIds,
                newLabels: newLabelsNames,
            });
        };
        _this.createTag = function (label) {
            return {
                id: label.id,
                label: label.name,
            };
        };
        _this.onSelect = function (label) {
            var selectedLabels = __spreadArrays(_this.state.selectedLabels, [label]);
            _this.setState({
                selectedLabels: selectedLabels,
            });
            _this.props.log(LabelsSelectorEvents.LABEL_SELECTED, { label: label.id });
            _this.fireOnChange({
                labels: selectedLabels,
                newLabels: _this.state.newLabels,
            });
        };
        _this.onHandleManualInput = function (tag) {
            var newLabel = {
                name: tag[0],
                id: Date.now().toString(),
            };
            var newLabels = __spreadArrays(_this.state.newLabels, [newLabel]);
            _this.setState({ newLabels: newLabels });
            _this.fireOnChange({
                labels: _this.state.selectedLabels,
                newLabels: newLabels,
            });
        };
        _this.onRemoveTag = function (tagId) {
            var selectedLabels = _this.state.selectedLabels.filter(function (label) { return label.id !== tagId; });
            var newLabels = _this.state.newLabels.filter(function (label) { return label.id !== tagId; });
            _this.setState({
                selectedLabels: selectedLabels,
                newLabels: newLabels,
            });
            _this.fireOnChange({
                labels: selectedLabels,
                newLabels: newLabels,
            });
        };
        _this.onChange = function (value) {
            _this.setState({
                inputValue: value,
            });
        };
        _this.predicate = function (option) {
            return ("" + option.value)
                .toLowerCase()
                .includes(_this.state.inputValue.toLowerCase());
        };
        _this.getCustomSuffix = function () {
            return (React.createElement(TextButton, { as: "a", size: "small", weight: "normal" },
                "+ ",
                _this.props.t('labelsSelector.addLabel')));
        };
        _this.state = {
            selectedLabels: props.labels.filter(function (l) { return props.selectedLabels.includes(l.id); }) || [],
            inputValue: '',
            newLabels: [],
        };
        return _this;
    }
    LabelsSelector.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (JSON.stringify(prevProps.newLabels) !==
            JSON.stringify(this.props.newLabels) ||
            JSON.stringify(prevProps.selectedLabels) !==
                JSON.stringify(this.props.selectedLabels)) {
            this.setState({
                newLabels: this.props.newLabels.map(function (l) { return ({
                    id: Date.now().toString(),
                    name: l,
                }); }) || [],
                selectedLabels: this.props.labels.filter(function (l) {
                    return _this.props.selectedLabels.includes(l.id);
                }) || [],
            });
        }
    };
    LabelsSelector.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, labels = _a.labels;
        var selectedLabels = __spreadArrays(this.state.selectedLabels, this.state.newLabels).map(this.createTag);
        return (React.createElement(React.Fragment, null,
            React.createElement(MultiSelect, { dataHook: "labels-selector", tags: selectedLabels, options: labels.map(this.convertLabelToOption), onSelect: this.onSelect, value: this.state.inputValue, predicate: this.predicate, onChange: function (e) {
                    _this.onChange(e.target.value);
                }, customSuffix: this.getCustomSuffix(), onRemoveTag: this.onRemoveTag, onManuallyInput: this.onHandleManualInput })));
    };
    return LabelsSelector;
}(React.PureComponent));
export default translate()(LabelsSelector);
//# sourceMappingURL=LabelsSelector.js.map